import React from 'react';
import PropTypes from 'prop-types';

const Submenu = ({ children, icon, title }) => (
  <div className="sidebar__submenu">
    <div className="sidebar__item">
      <div className="sidebar__item__icon">{icon}</div>
      <div className="sidebar__item__text">{title}</div>
    </div>
    <div className="sidebar__submenu__menu">
      {children}
    </div>
  </div>
);

Submenu.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Icona da mostrare per l'item */
  icon: PropTypes.element,
  /** Titolo dell'elemento */
  title: PropTypes.string,
};

Submenu.defaultProps = {
  children: null,
  icon: null,
  title: '',
};

export default Submenu;
